var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-primary"},[(_vm.preloader)?_c('app-overlay-loader'):_c('form-gen',{attrs:{"form-data-response":_vm.applicationForm},on:{"submit":_vm.updateSetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }